import { FiSearch } from 'react-icons/fi'
import Image from 'next/image'
import React from 'react'

import { CompanyFilter, DiscoverCompanies } from '@/features/resources'
import { useFilterBySearch } from '@/hooks'
import { useAllCompanies } from '@/api'
import { filterCompany } from '@/utils'

const Index = () => {
  const { searchTerm, handleSearchChange } = useFilterBySearch()
  const { searchTerm:searchIndustry, handleSearchChange:handleSearchIndustry } = useFilterBySearch()
  const [selectedItems, setSelectedItems] = React.useState<string[]>([])
  // const [searchIndustry, setSearchIndustry] = React.useState('')


  const { data, isLoading } = useAllCompanies()

  const allCompanyList = data?.data?.filter((company) => {
    const matchesSearchTerm = filterCompany(company, searchTerm || searchIndustry.toLowerCase())
    if (selectedItems.length === 0) {
      return matchesSearchTerm
    }
    const hasSelectedSize = selectedItems.some((size) => {
      const [start, end] = size.split('-').map((s) => parseInt(s.trim())) // Split and parse the selected size range
      const [min, max] = company.employeeCount
        .split('-')
        .map((s) => parseInt(s.trim())) // Split and parse the company's employee count range
      return min <= start && end <= max // Perform the range comparison
    })

    return matchesSearchTerm && hasSelectedSize
  })


  return (
    <div>
      <div className="sticky top-0 z-10 mb-10 flex h-56 w-full items-end bg-secondary p-6 px-16">
        <div className="mx-auto -mb-24 flex w-full max-w-[1500px] items-center justify-between rounded-lg bg-[#FFFFFF] shadow-lg ring-4 ring-gray-800 ring-offset-[-10px]">
          <div className="flex items-center space-x-7 p-4">
            <Image
              src="/assets/discoverCompanies-img.png"
              alt="icon"
              width={90}
              height={90}
            />
            <div>
              <p className="text-3xl font-bold text-black">
                Discover Companies
              </p>
              <p className="t font-light text-[#A6A6A6]">
                Get access to thousands of companies
              </p>
            </div>
          </div>

          <div className="flex w-[35rem] items-center gap-1 px-0 md:h-[70px] md:px-5">
            <div className="flex w-full items-center">
              <div className="flex h-[45px] w-full flex-row-reverse items-stretch gap-2">
                <input
                  type="text"
                  className="w-full rounded-md border-none bg-[#f0f0f0] px-4 font-WorkSans text-sm placeholder-[#A6A6A6] outline-none"
                  placeholder="Have a company in mind?"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>
            </div>
            <div className="hidden h-[45px] min-w-[45px] items-center justify-center bg-black text-center text-2xl text-white shadow-[3px_3px_0px_0px_#16BF44] transition duration-200 hover:bg-[#16BF44] hover:shadow-[-3px_3px_0px_0px_#191919] md:flex">
              <FiSearch />
            </div>
          </div>
        </div>
      </div>

      <section className="mt-24 px-16">
        <div className="mx-auto grid max-w-[1500px] grid-cols-12 items-start gap-5">
          <div className="sticky top-[310px] col-span-3 bg-white">
            <div className="rounded-lg bg-black p-6 text-white">
              <p className="text-xl font-bold ">Filter Companies</p>
              {allCompanyList && <p className="text-[#A6A6A6]">
                Showing <span className="font-semibold text-white">{allCompanyList?.length}</span>{' '}
                {allCompanyList?.length > 1 ? 'commpanies' : 'company'}
              </p>}
            </div>
            <CompanyFilter
              // setSearchIndustry={setSearchIndustry}
              setSelectedItems={setSelectedItems}
              selectedItems={selectedItems}
              handleSearchChange={handleSearchIndustry}
              searchTerm={searchIndustry}
            />
          </div>

          <div className="col-span-9">
            <DiscoverCompanies
              allCompanyList={allCompanyList || []}
              isLoading={isLoading}
            />
          </div>
        </div>
      </section>

      {/* <section className="my-32 px-16">
        <Link
          href="/resources/articles"
          className="mx-auto flex w-full max-w-[1500px] items-center justify-between rounded-lg bg-secondary px-8 py-4 "
        >
          <div className="flex items-center space-x-7">
            <Image
              src="/assets/article-img.png"
              alt="icon"
              width={80}
              height={80}
            />
            <div className="">
              <p className="text-2xl font-semibold text-white">
                Recent Articles
              </p>
              <p className="font-light text-[#A6A6A6]">
                Read interview questions ahead of time so you can prep with
                confidence.
              </p>
            </div>
          </div>

          <button className="whitespace-nowrap bg-secondary py-[12px] px-[26.8px] text-sm font-bold text-white shadow-[-6px_6px_0px_0px_#16BF44] transition duration-200 hover:bg-[#16BF44] hover:shadow-[6px_6px_0px_0px_#191919]">
            Explore
          </button>
        </Link>
        <div>
          <Articles />
        </div>
      </section> */}

      {/* <div className="my-32 px-16">
        <Link
          href="/resources/interview-questions"
          className="mx-auto flex w-full max-w-[1500px] items-center justify-between rounded-xl bg-secondary px-16 py-12 "
        >
          <div className="flex items-center space-x-7">
            <Image
              src="/assets/interviewQ-img.png"
              alt="icon"
              width={130}
              height={130}
            />
            <div>
              <p className="text-4xl font-semibold text-white">
                Prepare for Interviews
              </p>
              <p className="font-light text-[#A6A6A6]">
                Read interview questions ahead of time so you can prep with
                confidence.
              </p>
            </div>
          </div>

          <button className="whitespace-nowrap bg-secondary py-[12px] px-[26.8px] text-sm font-bold text-white shadow-[-6px_6px_0px_0px_#16BF44] transition duration-200 hover:bg-[#16BF44] hover:shadow-[6px_6px_0px_0px_#191919]">
            Explore Interview Questions
          </button>
        </Link>
      </div> */}
    </div>
  )
}

export default Index
